export default __webpack_public_path__ + "static/media/flower-interstitial-mobile-bg.40373026.webp";